import { ApplicantStatusReason } from '../offer/enums.js';

export type IOfferTimeline = {
  university: string;
  applicant_id: string;
  action: string;
  who: string;
  role: string;
  when: number;
  application_id?: string;
  offer_id?: string;
};

export enum OfferTimelineStageType {
  Applied = 'Applied',
  Conditional = 'Conditional',
  ConditionalReissued = 'ConditionalReissued',
  Unconditional = 'Unconditional',
  UnconditionalReissued = 'UnconditionalReissued',
  Withdrawn = 'Withdrawn',
  Rejected = 'Rejected',
  ProgrammeCreated = 'ProgrammeCreated',
  NewInformation = 'NewInformation',
  ProgrammeEdited = 'ProgrammeEdited',
  PreOfferTasksRequested = 'PreOfferTasksRequested',
  EnrolmentTasksRequested = 'EnrolmentTasksRequested',
}

export type IOfferTimelineEntry = {
  stageType: OfferTimelineStageType;
  stageFrom: OfferTimelineStageType | string;
  stageTo?: OfferTimelineStageType | string;
  showStageBadges?: boolean;
  stageReason?: ApplicantStatusReason;
  timestamp: number;
  /** Raw audit log action - used for display (e.g. "& pre-offer tasks requested", "& enrolment tasks requested") */
  action?: string;
};

export type GetOfferTimelineResponse = {
  offerTimeline: IOfferTimelineEntry[];
};
